import React, { useEffect } from "react";
import { Card, Form, Upload } from 'antd';
import FormItem from "components/fields/FormItem";
import { connect } from "react-redux";
import { 
	getJobApplicantDetails, doJobApplicantCreate, doJobApplicantUpdate 
} from "../../../../redux/jobapplicant/jobApplicantState";
import { requiredField } from "utils/crudSagaHelper";
import { Upload as UploadIcon } from "lucide-react";
import TextArea from "antd/lib/input/TextArea";

const JobFileAttachment = ({
	recordData,
	getDetails,
	doCreate, 
	doUpdate, 
	onCancel,
	submitLabel,
	getRecord,
	...props
}) => {
	

  
  	return (
	<div>
		<Card className="flex flex-col gap-6 rounded-xl relative border-2 border-purple-100">
			<h2 className="text-gray-900 mb-6 text-lg font-medium">Application Materials</h2>
			
			<Form className="form"
				layout="vertical"
				// onFinish={onSubmit}
			>   
				<FormItem
					name="resume"
					label="Resume / CV"
					rules={[requiredField()]}
					valuePropName="fileList"
					getValueFromEvent={(e) => e?.fileList}
				>
					<p className="text-base font-normal text-gray-700 px-2">PDF or Word document (max 5MB)</p>
					<Upload.Dragger
						accept=".pdf,.doc,.docx"
						maxCount={1}
						beforeUpload={() => false}
					>
						<div className="flex flex-col items-center gap-3 ">
							<div className="w-12 h-12 bg-gradient-to-r from-purple-100 to-emerald-100 rounded-lg flex items-center justify-center">
								<UploadIcon className="w-6 h-6 text-purple-600" />
							</div>
							<span className="text-gray-800 text-base">
								Click to upload resume
							</span>
						</div>
					</Upload.Dragger>
				</FormItem>

				<FormItem
					name="cover_letter"
					label="Cover Letter"
					rules={[requiredField()]}
					extra="mt-6"
				>
					<p className="text-base font-normal text-gray-700 px-2">Tell us why you're a great fit for this role</p>
					<TextArea
						rows={3}
						className="border-2 border-purple-200 hover:border-purple-200 focus:border-purple-400"
						placeholder="Share your motivation, relevant experience, and what excites you about this opportunity..."
					/>
				</FormItem>
			</Form>	 
			</Card>	
	</div>
	
  	);
};

const mapStateToProps = (state) => ({
  	recordData: state.jobRole.jobRoleDetails?.data,
});

const mapDispatchToProps = (dispatch) => ({
	getRecord: (id) => dispatch(getJobApplicantDetails(id)),
  	doCreate: (data) => dispatch(doJobApplicantCreate(data)),
  	doUpdate: (data) => dispatch(doJobApplicantUpdate(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(JobFileAttachment);
